import './_headerNavigation.scss'

import { AppBar, Toolbar, Box } from '@mui/material'
import useNavigationSelector from '../common/NavigationSelector'
import BlueLightCardLogo from 'components/Logo/BlueLightCardLogo'
import React from 'react'

const HeaderWithBlueLightCard = (): JSX.Element => {
  const { isSticky } = useNavigationSelector()

  return (
    <AppBar
      position="static"
      className={`HeaderNavigation-header centre-logo blc-header${isSticky ? '' : ' white-logo'}`}
    >
      <Toolbar className="HeaderNavigation-headerToolbar">
        <Box className="blc-quote-header">
          <BlueLightCardLogo />
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default HeaderWithBlueLightCard
